import styled from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _FooterPetitPrinceRoot = styled("div")`
  display: flex;
  flex-direction: column;
  width: 50%;

  @media ${responsiveMap.mobile} {
    width: 100%;
  }

  .footer-petit-prince__social-label {
    margin-bottom: 19px;

    @media ${responsiveMap.mobile} {
      max-width: 238px;
      margin-bottom: 7px;
    }
  }

  .footer-petit-prince__social-links {
    margin-bottom: 55px;

    @media ${responsiveMap.mobile} {
      margin-bottom: 43px;
    }
  }

  .footer-petit-prince__footer-text {
    width: 100%;
  }
`;
